import React, { useContext, useEffect, useState } from 'react';
import { compose } from 'recompose';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PageTitle } from '../blocks';
import Snackbar from '@/components/Snackbar';
import { Context, ContextProvider } from './store';
import SubregionsColumn from './SubregionsColumn';
import ZipsColumn from './ZipsColumn';
import MapColumn from './MapColumn';
import DeliveryProfileModal from './DeliveryProfileModal';

const AutoAssign = () => {
    const { state, loading, callbacks } = useContext(Context);
    // null when closed; an object (possibly null contents) when open. Holds the
    // profile being edited, or null for the create flow.
    const [profileModal, setProfileModal] = useState(null);
    const [subregionDetailsOpen, setSubregionDetailsOpen] = useState(false);

    useEffect(() => {
        setSubregionDetailsOpen(false);
    }, [state.selectedSubregion?.subregion_id]);

    if (state.scope.kind === 'corp' && !state.scope.org_id) {
        return (
            <Grid
                container
                direction="column"
                css={css`
                    height: 100%;
                    background: ${colors.white.primary};
                    align-items: center;
                    justify-content: center;
                    padding: 4rem;
                    text-align: center;
                `}
            >
                <PageTitle>Auto Assign Regions</PageTitle>
                <p>Your account is not associated with an organization — contact support.</p>
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="column"
            css={css`
                height: 100%;
                background: ${colors.white.primary};
                flex-wrap: nowrap;
            `}
        >
            <Snackbar
                open={!!state.notification.message}
                {...state.notification}
                handleClose={() => callbacks.setNotification({})}
            />
            <DeliveryProfileModal
                open={!!profileModal}
                onClose={() => setProfileModal(null)}
                deliveryProfile={profileModal?.profile || null}
                callbacks={{ upsertDeliveryProfile: callbacks.upsertDeliveryProfile }}
            />
            <Grid
                container
                css={css`
                    padding: 23px 45px;
                    border-bottom: 1px solid ${colors.greys[0]};
                    align-items: center;
                    justify-content: space-between;
                    flex: 0;
                `}
            >
                <PageTitle>Auto Assign Regions</PageTitle>
            </Grid>
            <Grid
                container
                css={css`
                    flex: 1;
                    flex-basis: 0;
                    flex-wrap: nowrap;
                `}
            >
                <SubregionsColumn
                    deliveryProfileId={state.deliveryProfileId}
                    deliveryProfiles={state.deliveryProfiles}
                    onSelectProfile={callbacks.selectDeliveryProfile}
                    onCreateProfile={() => setProfileModal({ profile: null })}
                    onEditProfile={() => setProfileModal({ profile: state.deliveryProfile })}
                    state={state}
                    loading={loading}
                    callbacks={callbacks}
                />
                <ZipsColumn
                    state={state}
                    loading={loading}
                    callbacks={callbacks}
                    onOpenSubregionDetails={() => setSubregionDetailsOpen((open) => !open)}
                />
                <MapColumn
                    state={state}
                    loading={loading}
                    callbacks={callbacks}
                    isOnwardAdmin={state.scope.kind === 'onward'}
                    carriersForLeg={state.carriersForLeg}
                    subregionDetailsOpen={subregionDetailsOpen}
                />
            </Grid>
        </Grid>
    );
};

const withContext = (Component) => (props) =>
    (
        <ContextProvider>
            <Component {...props} />
        </ContextProvider>
    );

export default compose(withContext)(AutoAssign);
